module.exports = __webpack_public_path__ + "img/Vonage_Jumper_icon_whitebg_horizontal.cbcdb4d9.svg";